// extracted by mini-css-extract-plugin
export default {"cover":"style_cover__4nJ+i","image":"style_image__eD5C-"};